<div class="grid-section">
	<div class="form-area">
		<img src="assets/icons/dexter-icons/dexter-action-icon.svg" />
		<div class="title">Awesome!</div>
		<div class="sub-title">You are all setup and ready.</div>
	</div>
</div>
